import React from "react";
import StudentHostelDetailsCreate from "../../components/AdminTabs/AdminStudentHostelFee/StudentHostelDetailsCreate";

const StudentHostelDetailsCreatePage = () => {
  return (
    <div>
      <StudentHostelDetailsCreate />
    </div>
  );
};

export default StudentHostelDetailsCreatePage;
